"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mouseCoordinates = exports.cellEditMode = void 0;
exports.resetSelectedCell = resetSelectedCell;
exports.setSelectedCell = setSelectedCell;
exports.resetSelectedForDrag = resetSelectedForDrag;
exports.setSelectedForDragData = setSelectedForDragData;
exports.addCellData = addCellData;
exports.removeCellData = removeCellData;
exports.addSingleCellData = addSingleCellData;
exports.removeSingleCellData = removeSingleCellData;
exports.resetSelectCopyOrCut = resetSelectCopyOrCut;
exports.removeUnselectedCopyCells = removeUnselectedCopyCells;
exports.handleMouseUp = handleMouseUp;
exports.toggleOverrideNativeKeyboardShortcuts = toggleOverrideNativeKeyboardShortcuts;
exports.makeRectangle = makeRectangle;
exports.handleCellCopyOrCut = handleCellCopyOrCut;
exports.handleCellDelete = handleCellDelete;
exports.selectCellsForDeletion = selectCellsForDeletion;
exports.resetDeleteSelection = resetDeleteSelection;
exports.handleCellPaste = handleCellPaste;
exports.handleSelectAll = handleSelectAll;
exports.openCellEditMenuOnCell = openCellEditMenuOnCell;
exports.closeCellEditMenu = closeCellEditMenu;
exports.handleRightClickCell = handleRightClickCell;
exports.initCellEdit = initCellEdit;
exports.destroyCellEdit = destroyCellEdit;
const vue_1 = require("vue");
const summaryCellRequest_1 = require("../requests/summaryCellRequest");
const summary_lib_1 = require("../js/summary_lib");
const slot_crud_common_1 = require("../js/slot_crud_common");
const common_1 = require("../common/common");
const timeZones_1 = __importDefault(require("../common/timeZones"));
const slot_undo_1 = require("../js/slot_undo");
exports.cellEditMode = (0, vue_1.reactive)({
    isOn: false,
    isCmdOrMetaKeyPressed: false,
    isDragging: false,
    isMouseDown: false,
    selectedCell: {
        id: "",
        userId: "",
        date: "",
        slotIds: [],
    },
    selectedCellForDrag: {
        id: "",
        userId: "",
        date: "",
        slotIds: []
    },
    copyCellData: {},
    singleCopyCellData: {},
    isMenuVisible: false,
    canSelectSeparately: true,
});
exports.mouseCoordinates = (0, vue_1.reactive)({
    mouseX: 0,
    mouseY: 0,
});
function getUserCopyCellData(source, userId) {
    return source[userId];
}
function getCellState(source, userId, date) {
    return source[userId]?.[date];
}
function getOrCreateUserCopyCellData(source, userId) {
    const existingUserCopyCellData = source[userId];
    if (existingUserCopyCellData) {
        return existingUserCopyCellData;
    }
    const createdUserCopyCellData = {};
    source[userId] = createdUserCopyCellData;
    return createdUserCopyCellData;
}
// CellEditMode state functions
function resetCellData(retainEditMode = true) {
    if (!retainEditMode) {
        exports.cellEditMode.selectedCell = {
            id: "",
            userId: "",
            date: "",
            slotIds: [],
        };
    }
    exports.cellEditMode.isOn = retainEditMode;
    exports.cellEditMode.isCmdOrMetaKeyPressed = false;
    exports.cellEditMode.copyCellData = {};
    exports.cellEditMode.singleCopyCellData = {};
    exports.cellEditMode.selectedCellForDrag = {
        id: "",
        userId: "",
        date: "",
    };
    exports.cellEditMode.isMenuVisible = false;
}
function resetSelectedCell() {
    exports.cellEditMode.selectedCell.id = "";
    exports.cellEditMode.selectedCell.userId = "";
    exports.cellEditMode.selectedCell.date = "";
    exports.cellEditMode.selectedCell.slotIds = [];
    exports.cellEditMode.isMenuVisible = false;
}
function setSelectedCell(data) {
    exports.cellEditMode.selectedCell.id = data.id;
    exports.cellEditMode.selectedCell.userId = data.userId;
    exports.cellEditMode.selectedCell.date = data.date;
    if (data.slotIds) {
        exports.cellEditMode.selectedCell.slotIds = data.slotIds;
    }
}
function resetSelectedForDrag() {
    exports.cellEditMode.selectedCellForDrag.id = "";
    exports.cellEditMode.selectedCellForDrag.userId = "";
    exports.cellEditMode.selectedCellForDrag.date = "";
}
function setSelectedForDragData(data) {
    exports.cellEditMode.selectedCellForDrag.id = data.id;
    exports.cellEditMode.selectedCellForDrag.userId = data.userId;
    exports.cellEditMode.selectedCellForDrag.date = data.date;
}
function addCellData(userId, dateString) {
    const userCopyCellData = getOrCreateUserCopyCellData(exports.cellEditMode.copyCellData, userId);
    userCopyCellData[dateString] = {
        isSelectedForCopy: false,
        isSelectedForCut: false,
        isSelectedForDelete: false,
        slotIds: [],
    };
}
function removeCellData(userId, dateString) {
    const userCopyCellData = getUserCopyCellData(exports.cellEditMode.copyCellData, userId);
    if (userCopyCellData?.[dateString]) {
        delete userCopyCellData[dateString];
        if (Object.keys(userCopyCellData).length === 0) {
            delete exports.cellEditMode.copyCellData[userId];
        }
    }
}
async function addSingleCellData(userId, dateString) {
    const userCopyCellData = getOrCreateUserCopyCellData(exports.cellEditMode.singleCopyCellData, userId);
    userCopyCellData[dateString] = {
        isSelectedForCopy: false,
        isSelectedForCut: false,
        isSelectedForDelete: false,
        slotIds: [],
    };
}
function removeSingleCellData(userId, dateString) {
    const userCopyCellData = getUserCopyCellData(exports.cellEditMode.singleCopyCellData, userId);
    if (userCopyCellData?.[dateString]) {
        delete userCopyCellData[dateString];
        if (Object.keys(userCopyCellData).length === 0) {
            delete exports.cellEditMode.singleCopyCellData[userId];
        }
    }
}
function resetSelectCopyOrCut() {
    const selectedUserIds = Object.keys(exports.cellEditMode.copyCellData);
    selectedUserIds.forEach(userId => {
        const userCopyCellData = getUserCopyCellData(exports.cellEditMode.copyCellData, userId);
        if (!userCopyCellData) {
            return;
        }
        Object.values(userCopyCellData).forEach(states => {
            states.isSelectedForCopy = false;
            states.isSelectedForCut = false;
            states.isSelectedForDelete = false;
        });
    });
}
function removeUnselectedCopyCells() {
    Object.keys(exports.cellEditMode.copyCellData).forEach(userId => {
        const userCopyCellData = getUserCopyCellData(exports.cellEditMode.copyCellData, userId);
        if (!userCopyCellData) {
            return;
        }
        Object.keys(userCopyCellData).forEach(date => {
            const cellState = userCopyCellData[date];
            if (!cellState) {
                return;
            }
            if (!cellState.isSelectedForCopy && !cellState.isSelectedForCut) {
                delete userCopyCellData[date];
            }
        });
    });
}
// Keyboard/Mouse event functions
function handleMouseUp() {
    exports.cellEditMode.isMouseDown = false;
    exports.cellEditMode.isDragging = false;
}
function handleKeyup() {
    exports.cellEditMode.isCmdOrMetaKeyPressed = false;
}
function handleKeyboardShortcuts(event) {
    const isCmdOrCtrl = event.metaKey || event.ctrlKey;
    // Cmd or Ctrl key handling
    exports.cellEditMode.isCmdOrMetaKeyPressed = isCmdOrCtrl;
    if (isCmdOrCtrl) {
        switch (event.key) {
            case "c":
                handleCellCopyOrCut(true);
                event.stopPropagation();
                event.preventDefault();
                break;
            case "v":
                if (!event.repeat) {
                    handleCellPaste();
                    event.stopPropagation();
                    event.preventDefault();
                }
                break;
            case "x":
                handleCellCopyOrCut(false);
                event.stopPropagation();
                event.preventDefault();
                break;
            case "a":
                handleSelectAll();
                event.stopPropagation();
                event.preventDefault();
                break;
            case "d":
                handleDeselectAll();
                event.stopPropagation();
                event.preventDefault();
                break;
            case "Escape":
                destroyCellEdit();
                break;
            default:
                break;
        }
    }
    // Handle Escape key separately
    if (event.key === "Escape") {
        destroyCellEdit();
        event.preventDefault();
    }
    if (event.key === "Delete" || event.key === "Backspace") {
        handleCellDelete();
        event.preventDefault();
    }
}
function toggleOverrideNativeKeyboardShortcuts() {
    if (exports.cellEditMode.isOn) {
        document.addEventListener("keydown", handleKeyboardShortcuts);
        document.addEventListener("keyup", handleKeyup);
        document.addEventListener("mouseup", handleMouseUp);
    }
    else {
        document.removeEventListener("keydown", handleKeyboardShortcuts);
        document.removeEventListener("keyup", handleKeyup);
        document.removeEventListener("mouseup", handleMouseUp);
    }
}
// Selecting Cells helper functions
function isSequentialDate(dateStr1, dateStr2) {
    const d1 = new Date(dateStr1).getTime();
    const d2 = new Date(dateStr2).getTime();
    const diff = (d2 - d1) / (1000 * 60 * 60 * 24); // Difference in days
    return diff === 1; // Check if difference is exactly 1 day
}
function groupSequentialDates(userIds) {
    const userIdKeys = Object.keys(exports.cellEditMode.copyCellData);
    const sortedUserIds = userIdKeys.sort((a, b) => userIds.indexOf(a) - userIds.indexOf(b));
    const dates = Array.from(new Set(sortedUserIds.flatMap(userId => Object.keys(getUserCopyCellData(exports.cellEditMode.copyCellData, userId) ?? {})))).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    const groups = [];
    let currentGroup = [];
    for (const date of dates) {
        const lastDate = currentGroup[currentGroup.length - 1];
        if (!lastDate) {
            currentGroup.push(date);
            continue;
        }
        if (isSequentialDate(lastDate, date)) {
            // If consecutive, add to current group
            currentGroup.push(date);
        }
        else {
            // If not consecutive, push the current group and start a new one
            groups.push(currentGroup);
            currentGroup = [date];
        }
    }
    // Add the last group
    if (currentGroup.length > 0) {
        groups.push(currentGroup);
    }
    return groups;
}
function makeRectangle(cell1, cell2) {
    const employments = (0, summary_lib_1.getEmploymentStore)();
    const userIds = employments.query().map(e => e.getUserId());
    const dates = makeSequentialDates(new Date(cell2.date), new Date(cell1.date));
    const selectedIndices = [
        userIds.indexOf(cell1.userId),
        userIds.indexOf(cell2.userId),
    ];
    const [leastIdx, maxIdx] = [Math.min(...selectedIndices), Math.max(...selectedIndices)];
    for (let i = leastIdx; i <= maxIdx; i++) {
        const userId = userIds[i];
        if (!userId) {
            continue;
        }
        dates.forEach(date => {
            addCellData(userId, date);
        });
    }
}
function makeSequentialDates(date1, date2) {
    const startDate = new Date(Math.min(date1.getTime(), date2.getTime()));
    const endDate = new Date(Math.max(date1.getTime(), date2.getTime()));
    const dates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
        dates.push((0, common_1.yearMonthDateString)(currentDate, timeZones_1.default.ASIA_TOKYO));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
}
function groupRectangles() {
    const employments = (0, summary_lib_1.getEmploymentStore)();
    const userIds = employments.query().map(e => e.getUserId());
    const userIdKeys = Object.keys(exports.cellEditMode.copyCellData);
    const sortedUserIds = userIdKeys.sort((a, b) => userIds.indexOf(a) - userIds.indexOf(b));
    const firstSelectedUserId = sortedUserIds[0];
    const lastSelectedUserId = sortedUserIds[sortedUserIds.length - 1];
    if (!firstSelectedUserId || !lastSelectedUserId) {
        return [];
    }
    const startIndex = userIds.indexOf(firstSelectedUserId);
    const endIndex = userIds.indexOf(lastSelectedUserId);
    if (startIndex < 0 || endIndex < 0) {
        return [];
    }
    const sortedFilledIds = userIds.slice(startIndex, endIndex + 1);
    const groups = [];
    const seqDatesArray = groupSequentialDates(userIds);
    seqDatesArray.forEach(dates => {
        const matrix = sortedFilledIds.map(userid => dates.map(date => exports.cellEditMode.copyCellData[userid]?.[date] !== undefined));
        const visited = Array.from({ length: sortedFilledIds.length }, () => Array(dates.length).fill(false));
        const makeGroupRectData = (row, col) => {
            const group = [];
            const stack = [[row, col]];
            const initialVisitedRow = visited[row];
            const startUserId = sortedFilledIds[row];
            const startDate = dates[col];
            if (!initialVisitedRow || !startUserId || !startDate) {
                return group;
            }
            initialVisitedRow[col] = true;
            group.push({ userId: startUserId, date: startDate });
            const directions = [
                [1, 0], // Down
                [0, 1], // Right
                [-1, 0], // Up
                [0, -1] // Left
            ];
            while (stack.length > 0) {
                const cell = stack.pop();
                if (!cell) {
                    continue;
                }
                const [r, c] = cell;
                // Explore all four directions
                for (const [dr, dc] of directions) {
                    const nr = r + dr;
                    const nc = c + dc;
                    const matrixRow = matrix[nr];
                    const visitedRow = visited[nr];
                    const userId = sortedFilledIds[nr];
                    const date = dates[nc];
                    if (nr >= 0 && nr < sortedFilledIds.length && nc >= 0 && nc < dates.length && matrixRow?.[nc] && visitedRow && !visitedRow[nc] && userId && date) {
                        visitedRow[nc] = true;
                        group.push({ userId, date });
                        stack.push([nr, nc]);
                    }
                }
            }
            return group;
        };
        // Traverse the matrix to find rectangles
        for (let row = 0; row < sortedFilledIds.length; row++) {
            for (let col = 0; col < dates.length; col++) {
                if (matrix[row]?.[col] && !visited[row]?.[col]) {
                    const groupRectData = makeGroupRectData(row, col);
                    if (groupRectData.length > 0) {
                        groups.push(groupRectData);
                    }
                }
            }
        }
    });
    return groups;
}
function getRectangle(rectData) {
    const userDates = {};
    rectData.forEach(data => {
        const userDateSet = userDates[data.userId] ?? (userDates[data.userId] = new Set());
        userDateSet.add(data.date);
    });
    const allDates = Object.values(userDates).map(dates => Array.from(dates));
    const [firstDates, ...remainingDates] = allDates;
    if (!firstDates) {
        return [];
    }
    const commonDates = remainingDates.reduce((acc, dates) => {
        return acc.filter((date) => dates.includes(date));
    }, firstDates);
    const sequentialDates = [];
    for (const date of commonDates) {
        const previousDate = sequentialDates[sequentialDates.length - 1];
        if (!previousDate || isSequentialDate(previousDate, date)) {
            sequentialDates.push(date);
            continue;
        }
        break;
    }
    const filteredData = rectData.filter(item => sequentialDates.includes(item.date));
    return filteredData;
}
function findLargestRect(groupRectDatas) {
    return groupRectDatas.reduce((longest, current) => {
        return current.length > longest.length ? current : longest;
    }, []);
}
async function switchCellStates(selectedCellData, isCopy) {
    selectedCellData.forEach(data => {
        const cellState = getCellState(exports.cellEditMode.copyCellData, data.userId, data.date);
        if (!cellState) {
            return;
        }
        cellState.isSelectedForCut = !isCopy;
        cellState.isSelectedForCopy = isCopy;
        cellState.isSelectedForDelete = false;
    });
}
async function switchSingleCellState(userId, date, isCopy) {
    const cellState = getCellState(exports.cellEditMode.singleCopyCellData, userId, date);
    if (!cellState) {
        return;
    }
    cellState.isSelectedForCut = !isCopy;
    cellState.isSelectedForCopy = isCopy;
    cellState.isSelectedForDelete = false;
}
function switchDeleteStates(selectedCellData) {
    selectedCellData.forEach(data => {
        const cellState = getCellState(exports.cellEditMode.copyCellData, data.userId, data.date);
        if (!cellState) {
            return;
        }
        cellState.isSelectedForCut = false;
        cellState.isSelectedForCopy = false;
        cellState.isSelectedForDelete = true;
    });
}
function switchSingleCellDeleteState(userId, date) {
    const cellState = getCellState(exports.cellEditMode.singleCopyCellData, userId, date);
    if (!cellState) {
        return;
    }
    cellState.isSelectedForCut = false;
    cellState.isSelectedForCopy = false;
    cellState.isSelectedForDelete = true;
}
async function getSingleSelectedSlotIds() {
    return exports.cellEditMode.selectedCell.slotIds || [];
}
async function getSelectedSlotIds(selectedCellData) {
    const slotIdsArr = [];
    selectedCellData.forEach(data => {
        const cellState = getCellState(exports.cellEditMode.copyCellData, data.userId, data.date);
        if (cellState) {
            slotIdsArr.push(cellState.slotIds);
        }
    });
    return slotIdsArr.flat();
}
function getSelectedCellData() {
    const rect = groupRectangles();
    return exports.cellEditMode.canSelectSeparately ? rect.flat() : getRectangle(findLargestRect(rect));
}
// Key events handlers
async function handleCellCopyOrCut(isCopy) {
    try {
        let copyClipboardData = {
            isCopy: false,
            userIds: [],
            startDate: "",
            slotIds: []
        };
        if (Object.keys(exports.cellEditMode.singleCopyCellData).length > 0) {
            exports.cellEditMode.singleCopyCellData = {};
        }
        if (Object.keys(exports.cellEditMode.copyCellData).length <= 0) {
            const userId = exports.cellEditMode.selectedCell.userId;
            const date = exports.cellEditMode.selectedCell.date;
            if (!userId || !date) {
                return;
            }
            await addSingleCellData(userId, date);
            await switchSingleCellState(userId, date, isCopy);
            const slotIds = await getSingleSelectedSlotIds();
            copyClipboardData = {
                isCopy,
                userIds: [userId],
                startDate: date,
                slotIds: slotIds,
            };
        }
        else {
            const selectedCellData = getSelectedCellData();
            await switchCellStates(selectedCellData, isCopy);
            const slotIds = await getSelectedSlotIds(selectedCellData);
            const userIds = [...new Set(selectedCellData.map(p => p.userId))];
            const seqDates = [...new Set(selectedCellData.map(p => p.date).sort((a, b) => new Date(a).getTime() - new Date(b).getTime()))];
            const startDate = seqDates[0];
            if (!startDate) {
                return;
            }
            copyClipboardData = {
                isCopy,
                userIds,
                startDate,
                slotIds: slotIds,
            };
        }
        window.sessionStorage.setItem("copyCellClipboard", JSON.stringify(copyClipboardData));
    }
    catch (err) {
        throw err;
    }
}
async function handleCellDelete(cellSelection) {
    const selection = cellSelection ?? await selectCellsForDeletion();
    if (!selection.length) {
        return;
    }
    (0, summary_lib_1.openConfirmModal)("現在画面に表示されている選択中のシフトデータが削除されますがよろしいですか？　＊一度削除するとこのアクションは取り消せません。先にExcelダウンロードでバックアップすることをオススメします。＊", async () => {
        await deleteSlotsInSelectedCells(selection);
        resetDeleteSelection(selection);
    }, () => { resetDeleteSelection(selection); });
}
async function selectCellsForDeletion() {
    if (Object.keys(exports.cellEditMode.singleCopyCellData).length > 0) {
        exports.cellEditMode.singleCopyCellData = {};
    }
    const userId = exports.cellEditMode.selectedCell.userId;
    const date = exports.cellEditMode.selectedCell.date;
    // Highlight cells in delete mode
    if (Object.keys(exports.cellEditMode.copyCellData).length <= 0) {
        if (!userId || !date) {
            return [];
        }
        await addSingleCellData(userId, date);
        switchSingleCellDeleteState(userId, date);
        return [{ userId, date }];
    }
    const selectedCellData = getSelectedCellData();
    switchDeleteStates(selectedCellData);
    return selectedCellData;
}
function resetDeleteSelection(selection) {
    if (!selection || selection.length === 0) {
        return;
    }
    if (selection.length > 1) {
        resetSelectCopyOrCut();
        return;
    }
    const firstSelection = selection[0];
    if (!firstSelection) {
        return;
    }
    const { userId, date } = firstSelection;
    removeSingleCellData(userId, date);
}
async function deleteSlotsInSelectedCells(selectedCellData) {
    const me = (0, summary_lib_1.getMeStore)();
    if (!me || !selectedCellData) {
        return;
    }
    const slotIds = selectedCellData.length === 1
        ? await getSingleSelectedSlotIds()
        : await getSelectedSlotIds(selectedCellData);
    if (!slotIds.length) {
        return;
    }
    const deletedSlots = slotIds
        .map(slotId => {
        const slot = (0, summary_lib_1.getSlotFromSlotMap)(slotId);
        return slot ? structuredClone(slot) : undefined;
    })
        .filter(Boolean);
    try {
        const response = await (0, summaryCellRequest_1.deleteSummaryCell)(me.getActiveUserId(), me.getActiveBranchId(), slotIds);
        if (!response.success) {
            throw new Error();
        }
        (0, summary_lib_1.handleRawSlotsBulkSelectedDelete)(response.deleteList);
        (0, slot_undo_1.addBulkToUndoStack)(slot_undo_1.ACTIONS_TYPE.BULK_DELETE, deletedSlots);
    }
    catch {
        (0, summary_lib_1.openAlertModal)("エラーが発生しました。選択したシフトを削除できませんでした。ページを更新して、再度お試しください。");
    }
}
function buildPayloadForPaste() {
    let isCopy = true;
    const { userId, date } = exports.cellEditMode.selectedCell;
    if (!userId || !date) {
        return;
    }
    const data = window.sessionStorage.getItem("copyCellClipboard");
    if (!data) {
        return;
    }
    const parsedData = JSON.parse(data);
    if (parsedData.isCopy !== undefined) {
        isCopy = parsedData.isCopy;
    }
    // employments relies on {{ .users }} variable in summary.html for the order
    const employments = (0, summary_lib_1.getEmploymentStore)();
    const sortedEmp = employments.query();
    let usersIn = parsedData.userIds.map(id => parseInt(id));
    let usersOut = [parseInt(userId)];
    let firstIndex = 0;
    const userIndexMap = {};
    if (usersIn.length > 1) {
        sortedEmp.forEach((e, i) => {
            userIndexMap[e.getUserId()] = i;
        });
        const userOutIndex = userIndexMap[userId];
        if (userOutIndex === undefined) {
            return;
        }
        usersOut = [];
        let firstSelectedIndex;
        // get Index of selected users from the employments
        usersIn.forEach(uId => {
            const index = userIndexMap[uId];
            if (index === undefined) {
                return;
            }
            if (firstSelectedIndex === undefined) {
                firstSelectedIndex = index;
                firstIndex = index;
            }
            // calculate index' diffs, add the userOut's index
            const newUserOutIdx = (index - firstIndex) + userOutIndex;
            const userOut = sortedEmp[newUserOutIdx];
            if (userOut) {
                const userOutId = parseInt(userOut.getUserId());
                usersOut.push(userOutId);
            }
        });
        // if the length of userIn and usersOut are still not equal, that means user row is in the last,
        // if this is the case we remove part of the usersIn to equalize it to usersOut
        if (usersIn.length > usersOut.length) {
            usersIn = usersIn.slice(0, usersOut.length);
        }
    }
    const slotIdsInt = parsedData.slotIds.map(s => parseInt(s));
    const payload = {
        startDateIn: parsedData.startDate,
        userIdsIn: usersIn,
        startDateOut: date,
        userIdsOut: usersOut,
        slotIds: slotIdsInt,
    };
    return { payload, isCopy };
}
async function copyRequest(payload) {
    const me = (0, summary_lib_1.getMeStore)();
    const response = await (0, summaryCellRequest_1.copyPasteSummaryCell)(me.getActiveUserId(), me.getActiveBranchId(), payload);
    if (response) {
        (0, slot_crud_common_1.handleCreateSuccess)(response);
    }
    return response;
}
async function cutRequest(payload) {
    const me = (0, summary_lib_1.getMeStore)();
    const response = await (0, summaryCellRequest_1.cutPasteSummaryCell)(me.getActiveUserId(), me.getActiveBranchId(), payload);
    if (response) {
        (0, slot_crud_common_1.handleUpdateSuccess)(response);
    }
    return response;
}
async function handleCellPaste() {
    try {
        exports.cellEditMode.copyCellData = {};
        const data = buildPayloadForPaste();
        if (data === undefined) {
            return;
        }
        const { payload, isCopy } = data;
        // For cut, collect the slots that will be deleted
        let deletedSlots = [];
        if (!isCopy) {
            deletedSlots = payload.slotIds
                .map((id) => {
                const slot = (0, summary_lib_1.getSlotFromSlotMap)(id);
                return slot ? structuredClone(slot) : null;
            })
                .filter(Boolean);
        }
        let response;
        // Copy
        if (isCopy) {
            response = await copyRequest(payload);
            // Cut
        }
        else {
            response = await cutRequest(payload);
        }
        // Add to undo stack for paste
        const createdSlots = response.addList || [];
        if (createdSlots.length > 0) {
            if (isCopy) {
                (0, slot_undo_1.addBulkToUndoStack)(slot_undo_1.ACTIONS_TYPE.BULK_CREATE, createdSlots);
            }
            else {
                // For cut paste, undo both created and deleted
                (0, slot_undo_1.addBulkToUndoStack)(slot_undo_1.ACTIONS_TYPE.BULK_CUT, createdSlots, deletedSlots);
            }
        }
        resetCellData(true);
    }
    catch (err) {
        (0, summary_lib_1.openAlertModal)("エラーが発生しました。恐れ入りますが、再度お試しください。");
    }
}
function handleSelectAll() {
    const elements = document.querySelectorAll("td.dropzone");
    elements.forEach(element => {
        const userId = element.dataset.user || "";
        const date = element.dataset.date || "";
        addCellData(userId, date);
    });
}
function handleDeselectAll() {
    exports.cellEditMode.copyCellData = {};
    exports.cellEditMode.singleCopyCellData = {};
}
// Summary Toast function:
function toggleToast() {
    const toast = document.getElementById("summary-toast");
    if (!toast) {
        return;
    }
    if (exports.cellEditMode.isOn) {
        toast?.classList.remove("d-none");
    }
    else {
        toast?.classList.add("d-none");
    }
}
function openCellEditMenuOnCell() {
    exports.cellEditMode.isMenuVisible = true;
}
function closeCellEditMenu() {
    exports.cellEditMode.isMenuVisible = false;
}
function initTrackMouseCoordinateEvent() {
    document.addEventListener("contextmenu", handleRightClickCell);
    document.addEventListener("click", handleLeftClickCellEditMenu);
}
function destroyTrackMouseCoordinateEvent() {
    document.removeEventListener("contextmenu", handleRightClickCell);
    document.removeEventListener("click", handleLeftClickCellEditMenu);
}
function handleRightClickCell(event) {
    exports.mouseCoordinates.mouseX = event.clientX;
    exports.mouseCoordinates.mouseY = event.clientY;
    openCellEditMenuOnCell();
}
;
function handleLeftClickCellEditMenu() {
    exports.cellEditMode.isMenuVisible = false;
}
// Init Edit Mode
function initCellEdit() {
    exports.cellEditMode.copyCellData = {};
    exports.cellEditMode.isOn = true;
    toggleOverrideNativeKeyboardShortcuts();
    initTrackMouseCoordinateEvent();
    toggleToast();
}
// Destroy Edit mode
function destroyCellEdit() {
    resetCellData(false);
    toggleOverrideNativeKeyboardShortcuts();
    destroyTrackMouseCoordinateEvent();
    toggleToast();
}
